import React from 'react';

import styles from './styles.module.scss';

interface Props {
  type: 'add' | 'picture';
  callFileUploader: () => void;
  isEdit: boolean;
  cnt: number;
}

export default function Picture({type, callFileUploader, isEdit, cnt}: Props) {
  return (
    <div
      className={`picture-wrapper ${type === 'add' ? 'picture-add' : ''}`}
      onClick={() => (!isEdit ? callFileUploader() : '')}
      style={{cursor: 'pointer'}}>
      <div style={{display: type === 'add' ? 'block' : 'none'}}>
        <span className="icon add-picture-icon">&nbsp;</span>
        <div className="picture-cnt">
          <span className="cnt">{cnt}</span>/<span className="total">10</span>
        </div>
      </div>
      <div
        className={`cover ${styles.test}`}
        style={{display: isEdit ? 'block' : 'none'}}></div>
    </div>
  );
}
